import { SlideData } from '../features/types/types';
export const ACADEMY_SLIDES: SlideData[] = [
  {
    id: 1,
    category: 'dance',
    title: "The Art of Ballet",
    subtitle: "Master the elegance of classical movements with our expert instructors.",
    image: "/assets/imgs/gallery/acrylic/fall_acrylic.jpeg"
  },
  {
    id: 2,
    category: 'art',
    title: "Abstract Visions",
    subtitle: "Explore contemporary painting techniques and find your unique voice.",
    image: "/assets/imgs/gallery/oil/oil-4.jpeg"
  },
  {
    id: 3,
    category: 'dance',
    title: "Urban Rhythm",
    subtitle: "Energy, precision, and soul in our street dance and hip-hop intensives.",
    image: "/assets/imgs/gallery/dance_pics/nupur_dance_2.jpg"
  },
  {
    id: 4,
    category: 'dance',
    title: "Classsical Dance",
    subtitle: "Energy, precision, and soul in indian classical form.",
    image: "/assets/imgs/gallery/dance_pics/nupur_dance_3.jpg"
  },
    {
    id: 5,
    category: 'dance',
    title: "Award",
    subtitle: "Awards for best dance group in competition",
    image: "/assets/imgs/gallery/dance_pics/nupur_award.jpeg"
  },
    {
    id: 6,
    category: 'dance',
    title: "",
    subtitle: "",
    image: "/assets/imgs/gallery/dance_pics/nupur_award_group.jpeg"
  },
    {
    id: 7,
    category: 'dance',
    title: "",
    subtitle: "Energy, precision, and soul in indian classical form.",
    image: "/assets/imgs/gallery/dance_pics/nupur_group2.jpeg"
  },
      {
    id: 7,
    category: 'art',
    title: "",
    subtitle: "Art involvement",
    image: "/assets/imgs/gallery/dance_pics/nupur_art_10.jpeg"
  },
        {
    id: 7,
    category: 'dance',
    title: "",
    subtitle: "Art involvement",
    image: "/assets/imgs/gallery/dance_pics/nupur_group_dance_4.jpeg"
  }

];